import { portalPagesReducer } from './portalPages.reducer'
export * from './portalPages.actions'
export * from './portalPages.thunks'

export default portalPagesReducer
